export const isLusiniPluginEnabled =
  typeof window !== 'undefined' &&
  localStorage.getItem('lusini-plugin') === 'true'
